import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

// -- INE Reports
export const GET_INE_ILEGGELSE_REPORTS_URL = (reportStyle) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/ine_ileggelse_reports/${reportStyle}`;
